import { render, staticRenderFns } from "./StatusCode.vue?vue&type=template&id=0831bbf1&scoped=true&"
var script = {}
import style0 from "./StatusCode.vue?vue&type=style&index=0&id=0831bbf1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831bbf1",
  null
  
)

export default component.exports